import { render } from "./MatchmakerChart.vue?vue&type=template&id=36e119fe&scoped=true"
import script from "./MatchmakerChart.vue?vue&type=script&lang=js"
export * from "./MatchmakerChart.vue?vue&type=script&lang=js"

import "./MatchmakerChart.vue?vue&type=style&index=0&id=36e119fe&lang=scss&scoped=true"

import exportComponent from "C:\\Jenkins\\workspace\\BT5\\rptrweb\\release-RPTRWEB-3586\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36e119fe"]])

export default __exports__